import { CreateExperienceProductTargetingFeDto } from "@intelligems/ig-types";

export const checkForExperienceProductTargetingExpression = (
  experienceProductTargeting: CreateExperienceProductTargetingFeDto[]
) => {
  return (
    experienceProductTargeting.length > 0 &&
    Boolean(experienceProductTargeting[0].expression)
  );
};

export const splitProductTargetingValueString = (valueString: string) => {
  if (valueString === "") return [];
  return valueString.split(",");
};
